import {EventEmitter} from 'events';

class HidePrice extends EventEmitter {
  hidePrice = (localStorage.getItem('hide_price') ?? false) === 'true';

  constructor() {
    super();

    window.addEventListener('storage', () => {
      const tmpPrice = (localStorage.getItem('hide_price') ?? false) === 'true';

      if (this.hidePrice !== tmpPrice) {
        this.hidePrice = tmpPrice;
        this.emit('update');
      }
    })
  }

  setHidden(hidden) {
    this.hidePrice = hidden;

    this.emit('update');
    localStorage.setItem('hide_price', this.hidePrice ? 'true' : 'false');
  }

  toggleHidden() {
    this.setHidden(!this.hidePrice);
  }
}

export default new HidePrice;
